import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "katex/dist/katex.min.css";
import { App } from "./app";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root was not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
